// @flow
import type { Action } from 'app/common/redux/types';

export type State = {|
  didPinCloseup: boolean,
  didPinClickthrough: boolean,
  didPinSave: boolean,
  didAppInstall: boolean,
|};

const initialState = {
  didPinCloseup: false,
  didPinClickthrough: false,
  didPinSave: false,
  didAppInstall: false,
};

const checklist = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'UPDATE_PIN_ACTIONS':
      const { didPinCloseup, didPinClickthrough, didPinSave, didAppInstall } = action.payload;
      return { ...state, didPinCloseup, didPinClickthrough, didPinSave, didAppInstall };
    case 'COMPLETE_PIN_CLOSEUP':
      return { ...state, didPinCloseup: true };
    case 'COMPLETE_PIN_CLICKTHROUGH':
      return { ...state, didPinClickthrough: true };
    case 'COMPLETE_PIN_SAVE':
      return { ...state, didPinSave: true };
    case 'COMPLETE_APP_INSTALL':
      return { ...state, didAppInstall: true };
    default:
      return state;
  }
};

export default checklist;
